
import { FundStatus } from '@common/enums';

import { State } from '@app/common/enums/state.enum';

import { EnvironmentDisease } from './environment-disease';

export interface Disease {
  readonly id: number;
  typeId?: number;
  name?: string;
  state?: State;
  fundStatuses?: FundStatus[];
  environmentDiseases?: EnvironmentDisease[];
  color?: string;
  allFoundations?: string;
  environmentFundsCount?: string;
  environmentFoundationsCount?: string;
}
